module.exports = __webpack_public_path__ + "img/first-reader-logo.88a16682.png";